// core
import { useEffect, useState } from "react";
import { Form, Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// ui primitives (replaced @mui/material — see Components/UI)
import {
    Button,
    Card,
    CircularProgress,
    Stack,
    TextField,
} from "Components/UI";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightToBracket, faUser } from "@fortawesome/free-solid-svg-icons";

// services
import { useResetPassword } from "Services/LoginAPI";

// styles
import styles from "./LoginForm.module.css";
import LoginLogo from "./LoginLogo";

// main component
export default function ForgotLoginForm() {
    // injections
    const location = useLocation();
    const navigate = useNavigate();

    // own state
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState(() => {
        const initialUsername = location?.state?.username;
        return typeof initialUsername === "string" ? initialUsername : "";
    });

    // private methods
    function DoReset() {
        setLoading(true);
        useResetPassword(username)
            .then((response) => {
                if (response.status) {
                    console.log(response);
                    if (response.status === true) {
                        toast.success(
                            "Password reset email sent, please check you inbox."
                        );
                        setTimeout(() => {
                            navigate("/");
                        }, 4000);
                    } else {
                        setErrorMessage(response.info);
                    }
                } else {
                    setErrorMessage(response.info);
                }
            })
            .catch((error) => {
                setErrorMessage(error.toString());
                console.log(error);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    // watchers
    useEffect(() => {
        if (errorMessage && errorMessage.length > 2) toast.error(errorMessage);
    }, [errorMessage]);

    // render
    return (
        <Card>
            <Stack align="center" fullWidth>
                <LoginLogo />
            </Stack>

            <div className={styles.formBlock}>
                <Form>
                    <Stack gap={2}>
                        <TextField
                            error={!username}
                            helperText={!username && "Email is required"}
                            fullWidth
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            label={
                                <>
                                    {" "}
                                    <FontAwesomeIcon
                                        icon={faUser}
                                    /> Email{" "}
                                </>
                            }
                        />

                        <Button
                            onClick={DoReset}
                            type="submit"
                            className={styles.submitButton}
                            disabled={loading}
                        >
                            Reset Password&nbsp;
                            {loading ? (
                                <CircularProgress size={18} />
                            ) : (
                                <FontAwesomeIcon icon={faRightToBracket} />
                            )}
                        </Button>
                    </Stack>
                </Form>
            </div>

            <Stack align="center" fullWidth mt={3}>
                <Link to="/login" className={styles.link}>
                    Back to Login
                </Link>
            </Stack>
        </Card>
    );
}
